import type { NotificationItem } from '../../services/notifications.service';
import type { NotificationsFilter } from './notifications.types';

export interface NotificationsPageState {
  items: NotificationItem[];
  totalItems: number;
  page: number;
  pageSize: number;
  filter: NotificationsFilter;
  loading: boolean;
  error: string | null;
  hasLoaded: boolean;
}

export interface NotificationsState {
  unreadCount: number;
  page: NotificationsPageState;
}

export const initialNotificationsState: NotificationsState = {
  unreadCount: 0,
  page: {
    items: [],
    totalItems: 0,
    page: 1,
    pageSize: 10,
    filter: 'all',
    loading: false,
    error: null,
    hasLoaded: false,
  },
};
